/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Internal_NotesInputs */

const cs_form_internal_notes = /** @type {(inputs: Form_Internal_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interní poznámky`)
};

const en_form_internal_notes = /** @type {(inputs: Form_Internal_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal notes`)
};

/**
* | output |
* | --- |
* | "Internal notes" |
*
* @param {Form_Internal_NotesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_internal_notes = /** @type {((inputs?: Form_Internal_NotesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Internal_NotesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_internal_notes(inputs)
	return cs_form_internal_notes(inputs)
});